import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "sections-container" }
const _hoisted_2 = { class: "d-flex align-center mb-2" }
const _hoisted_3 = { class: "text-subtitle-1 font-weight-bold text-white mr-2" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "d-flex justify-space-between align-start mb-1 ga-1" }
const _hoisted_6 = {
  class: "d-flex flex-column text-truncate",
  style: {"max-width":"65%"}
}
const _hoisted_7 = ["title"]
const _hoisted_8 = { class: "operability-bar-wrapper mb-1" }
const _hoisted_9 = { class: "operability-stacked-bar" }
const _hoisted_10 = ["title"]
const _hoisted_11 = ["title"]
const _hoisted_12 = ["title"]
const _hoisted_13 = ["title"]
const _hoisted_14 = {
  class: "d-flex justify-space-between align-center",
  style: {"font-size":"0.60rem !important"}
}
const _hoisted_15 = { class: "ip-text" }

import { LATENCY } from '@/interfaces/SmartLink/Topology';
import { getDeviceModel } from '@/utils/SmartLink/device';


export default /*@__PURE__*/_defineComponent({
  __name: 'LatencyGrid',
  props: {
    filteredGroups: {},
    getLatencyColor: { type: Function },
    getOperabilityPercentages: { type: Function },
    formatShortDate: { type: Function }
  },
  emits: ["select-device"],
  setup(__props: any) {





return (_ctx: any,_cache: any) => {
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[0] || (_cache[0] = _createStaticVNode("<div class=\"card-grid-legend d-flex align-center flex-wrap ga-4 pa-2 mb-3\"><span class=\"legend-title font-weight-bold\">Estado:</span><div class=\"d-flex align-center ga-1\"><span class=\"legend-color-dot\" style=\"background-color:#00E676;\"></span><span class=\"legend-text\">OK (≤ 100 ms)</span></div><div class=\"d-flex align-center ga-1\"><span class=\"legend-color-dot\" style=\"background-color:#FFEA00;\"></span><span class=\"legend-text\">Moderado (101 - 500 ms)</span></div><div class=\"d-flex align-center ga-1\"><span class=\"legend-color-dot\" style=\"background-color:#FF3D00;\"></span><span class=\"legend-text\">Crítico (&gt; 500 ms)</span></div><div class=\"d-flex align-center ga-1\"><span class=\"legend-color-dot\" style=\"background-color:#9E9E9E;\"></span><span class=\"legend-text\">Desconectado (OFF)</span></div></div>", 1)),
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.filteredGroups, (group) => {
        return (_openBlock(), _createElementBlock("div", {
          key: group.subtipo,
          class: "mb-4"
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("span", _hoisted_3, _toDisplayString(group.title), 1),
            _createVNode(_component_v_chip, {
              size: "x-small",
              color: "grey-darken-2",
              variant: "flat",
              class: "px-1",
              style: {"height":"16px","font-size":"0.65rem"}
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(group.items.length), 1)
              ]),
              _: 2
            }, 1024)
          ]),
          (group.items.length > 0)
            ? (_openBlock(), _createBlock(_component_v_row, {
                key: 0,
                class: "ma-0",
                dense: ""
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.items, (item) => {
                    return (_openBlock(), _createBlock(_component_v_col, {
                      key: item.ip,
                      cols: "12",
                      sm: "4",
                      md: "3",
                      lg: "2",
                      xl: "1",
                      class: "pa-1",
                      style: {"min-width":"12.5%"}
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", {
                          class: "card-device-ultracompact pa-1 px-2",
                          onClick: ($event: any) => (_ctx.$emit('select-device', item))
                        }, [
                          _createElementVNode("div", _hoisted_5, [
                            _createElementVNode("div", _hoisted_6, [
                              _createElementVNode("span", {
                                class: "device-name font-weight-bold text-truncate text-white",
                                title: item.name
                              }, _toDisplayString(item.name), 9, _hoisted_7),
                              _createElementVNode("span", {
                                class: _normalizeClass(["device-model text-truncate", _unref(getDeviceModel)(item.anotacion) === 'S/M' ? 'text-grey-darken-1' : 'text-primary-lighten-2'])
                              }, _toDisplayString(_unref(getDeviceModel)(item.anotacion)), 3)
                            ]),
                            _createElementVNode("span", {
                              class: "latency-badge font-weight-bold",
                              style: _normalizeStyle({ color: __props.getLatencyColor(item.latencia), borderColor: __props.getLatencyColor(item.latencia) })
                            }, _toDisplayString(item.latencia < 0 ? 'OFF' : `${item.latencia}ms`), 5)
                          ]),
                          _createElementVNode("div", _hoisted_8, [
                            _createElementVNode("div", _hoisted_9, [
                              _createElementVNode("div", {
                                class: "bar-segment",
                                style: _normalizeStyle([{"background-color":"#00E676"}, { width: __props.getOperabilityPercentages(item.ip).ok + '%' }]),
                                title: `Excelente estado: ${__props.getOperabilityPercentages(item.ip).ok.toFixed(1)}%`
                              }, null, 12, _hoisted_10),
                              _createElementVNode("div", {
                                class: "bar-segment",
                                style: _normalizeStyle([{"background-color":"#FFEA00"}, { width: __props.getOperabilityPercentages(item.ip).alert + '%' }]),
                                title: `Alerta leve: ${__props.getOperabilityPercentages(item.ip).alert.toFixed(1)}%`
                              }, null, 12, _hoisted_11),
                              _createElementVNode("div", {
                                class: "bar-segment",
                                style: _normalizeStyle([{"background-color":"#FF3D00"}, { width: __props.getOperabilityPercentages(item.ip).alarm + '%' }]),
                                title: `Alarma crítica: ${__props.getOperabilityPercentages(item.ip).alarm.toFixed(1)}%`
                              }, null, 12, _hoisted_12),
                              _createElementVNode("div", {
                                class: "bar-segment",
                                style: _normalizeStyle([{"background-color":"#9E9E9E"}, { width: __props.getOperabilityPercentages(item.ip).down + '%' }]),
                                title: `Fuera de servicio: ${__props.getOperabilityPercentages(item.ip).down.toFixed(1)}%`
                              }, null, 12, _hoisted_13)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_14, [
                            _createElementVNode("span", _hoisted_15, _toDisplayString(item.ip), 1),
                            _createElementVNode("span", null, "Upd: " + _toDisplayString(__props.formatShortDate(item.fecha)), 1)
                          ])
                        ], 8, _hoisted_4)
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 2
              }, 1024))
            : _createCommentVNode("", true)
        ]))
      }), 128))
    ])
  ], 64))
}
}

})